
import Privacy from "./privacidad"
import Lottie from 'react-lottie-player'
import animation from './splash_animation.json'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import './style.css'
import './video-react.css'

import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import TandC from "./terminosycondiciones";
import DeleteAccountInfo from "./deleteAccountInfo";
import YoutubeFrame from "./youtubeIFrame";
import DailyMotionFrame from "./dailymotionFrame";
import Share from "./share.js"

// URL de tu app en Google Play
const googlePlayUrl = 'https://play.google.com/store/apps/details?id=com.firefly.opentv';

// URL del icono de tu app (puedes reemplazarlo con una imagen local)
const appIcon = "/logo512.png";



function App() {
  return (
    <Router>
      <div className={"site-content"}>
        <Route path="/" exact component={LandingPage} />
        <Route path="/privacidad/" component={Privacy} />
        <Route path="/terminosycondiciones/" component={TandC} />
        <Route path="/privacidad.html/" component={Privacy} />
        <Route path="/eliminarCuenta" component={DeleteAccountInfo} />
        <Route path="/youtubeframe" component={YoutubeFrame} />
        <Route path="/dailymotionframe" component={DailyMotionFrame} />
        <Route path="/share/:sharekey" component={Share} />
      </div>
    </Router>
  );
}

function LandingPage() {
  return (
    <Container fluid className="text-center bg-dark text-white d-flex align-items-center justify-content-center min-vh-100">
      <div className="p-4 p-md-5 mx-auto">
        <Row className="justify-content-center align-items-center mb-4">
          <Col xs={12} md={4} className="mb-4 mb-md-0">
            <Image 
              src={appIcon} 
              alt="Icono de la app Open TV" 
              className="app-icon shadow-lg rounded-circle"
            />
          </Col>
          <Col xs={12} md={8}>
            <h1 className="display-4 fw-bold mb-3">Tv en vivo</h1>
            <p className="lead fw-normal">
              Disfruta de la mejor televisión en vivo y canales de señal abierta directamente en tu dispositivo móvil.
            </p>
            <p className="lead fw-normal">
              Conecta a tu TV con Chromecast y no te pierdas tus programas favoritos.
            </p>
          </Col>
        </Row>
        
        <div className="d-grid gap-2 col-6 mx-auto mt-4">
          <Button 
            href={googlePlayUrl}
            variant="success"
            size="lg"
            target="_blank"
            rel="noopener noreferrer"
          >
            Descargar en Google Play
          </Button>
        </div>

        <div className="mt-4 d-flex flex-column align-items-center gap-2">
          <Link to="/privacidad/" className="text-white text-decoration-underline">
            Política de privacidad
          </Link>
          <Link to="/terminosycondiciones/" className="text-white text-decoration-underline">
            Términos y condiciones
          </Link>
        </div>
      </div>
    </Container>
  );
}

export default App;
